export function sanitizePhoneInput(value: string) {
  return value.replace(/[^\d+\s-]/g, "").slice(0, 16)
}

export function isIsraeliMobilePhone(value: string) {
  const digits = value.replace(/\D/g, "")
  return /^(?:0?972|0)5\d{8}$/.test(digits)
}
